var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"not-msg"},[_c('div',{staticClass:"not-msg-code"},[_vm._v("505")]),_c('div',{staticClass:"not-msg-text1"},[_vm._v("别担心，我们很快就能修好")]),_c('div',{staticClass:"not-msg-text2"},[_vm._v("谢谢!")])])
}]

export { render, staticRenderFns }